import { ResourceType } from "@/models/common"
import { FileMetaData, IFile } from "@/models/File"
import { User } from "@/models/User"

export interface IDemoVideo {
  id: string
  targetId: string
  targetType: ResourceType
  videoUrl: string
  fileMetadataId: string
  fileMetadata?: IFile
  current: boolean
  deleted: boolean
  createdDate: string
  modifiedDate: string
  createdBy?: string
  owner?: User
}

export type DemoVideoCreatePayload = {
  projectId?: string
  resourceType: ResourceType
  targetId: string
  videoUrl?: string
  fileMetadataId?: string
}

export type DemoVideoListPayload = {
  projectId?: string
  resourceType: ResourceType
  targetId: string
}

export type DemoVideoDeletePayload = {
  projectId?: string
  demoVideoId: string
}

export class DemoVideo {
  id = ""
  targetId = ""
  targetType: ResourceType = "ITEM"
  videoUrl = ""
  fileMetadataId = ""
  fileMetadata?: FileMetaData
  current = false
  deleted = false
  createdDate = ""
  modifiedDate = ""
  createdBy = ""
  owner: User | null = null

  constructor(props?: Partial<IDemoVideo>) {
    if (!props) return

    this.id = props.id ?? ""
    this.targetId = props.targetId ?? ""
    this.targetType = props.targetType ?? "ITEM"
    this.videoUrl = props.videoUrl ?? ""
    this.fileMetadataId = props.fileMetadataId ?? ""
    this.fileMetadata = props.fileMetadata ? FileMetaData.create(props.fileMetadata) : undefined
    this.current = props.current ?? false
    this.deleted = props.deleted ?? false
    this.createdDate = props.createdDate ?? ""
    this.modifiedDate = props.modifiedDate ?? ""
    this.createdBy = props.createdBy ?? ""
    this.owner = props.owner ? User.create(props.owner) : null
  }

  static create(props?: Partial<IDemoVideo>): DemoVideo {
    return new DemoVideo(props)
  }
}
